import { render, staticRenderFns } from "./HeaderConsumer.vue?vue&type=template&id=04a168ee&scoped=true&"
import script from "./HeaderConsumer.vue?vue&type=script&lang=js&"
export * from "./HeaderConsumer.vue?vue&type=script&lang=js&"
import style0 from "./HeaderConsumer.vue?vue&type=style&index=0&id=04a168ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a168ee",
  null
  
)

export default component.exports